// @ts-nocheck
// useAuthentication.js
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import jwtDecode from 'jwt-decode';
import { URL } from '../service/Service';

function useAuthentication() {
  const location = useLocation();
  const token = sessionStorage.getItem('jwt');
  const navigate = useNavigate();

  useEffect(() => {
    const publicPaths = ['/', '/login', '/resetpassword'];
    const isPublicPath = publicPaths.includes(location.pathname) || location.pathname.startsWith('/resetpassword/');
    if (!token && !isPublicPath) {
      navigate('/login');
    } else if (token) {
      // Valida o token e redireciona com base no papel do usuário
      axios.get(`${URL}/api/validate`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      .then(response => {
        const role = jwtDecode(token).authorities[0].authority;

        if ((role === 'ADMIN' || role === 'MANAGER') && !location.pathname.startsWith('/admin/')) {
          navigate('/admin/dashboard'); // Adjust this path to your main admin route
        } else if (role === 'PARTNER' && !location.pathname.startsWith('/user/')) {
          navigate('/user/dashboard');
        }
      })
      .catch(error => {
        console.log(error);
        sessionStorage.removeItem('jwt');
        sessionStorage.removeItem('userRole');
        navigate('/login');
      });
    }
  }, [token, location.pathname, navigate]);
}

export default useAuthentication;
